<template>
    <section id="reports" class="reports">
        <div data-aos="flip-up" data-aos-duration="1000" class="section-title">
            <h2>آمار و ارقام</h2>
            <p>گزارشات آماری رامنیک</p>
        </div>
        <div class="col-12">
            <div data-aos="fade-right"
                 data-aos-duration="1000"
                 class="col-lg-3 col-md-6 col-6 d-flex align-items-stretch float-dynamic">
                <div class="w-100 text-center">
                    <number class="number"
                            :from="0"
                            :to="168590"
                            :duration="3"
                            :delay="1"
                            easing="Power1.easeOut" />
                    <hr />
                    <strong class="text-muted">دارندگان نیکارت</strong>
                    <p>تعداد افرادی که نیکارت خود را دریافت کرده اند</p>
                </div>
            </div>
            <div data-aos="fade-down"
                 data-aos-duration="1000"
                 class="col-lg-3 col-md-6 col-6 d-flex align-items-stretch float-dynamic">
                <div class="w-100 text-center">
                    <number class="number"
                            :from="0"
                            :to="1970"
                            :duration="3"
                            :delay="1"
                            easing="Power1.easeOut" />
                    <hr />
                    <strong class="text-muted">پذیرندگان نیکارت</strong>
                    <p>تعداد فروشگاه هایی که خدمات خود را توسط نیکارت ارائه میکنند</p>
                </div>
            </div>
            <div data-aos="fade-down"
                 data-aos-duration="1000"
                 class="col-lg-3 col-md-6 col-6 d-flex align-items-stretch float-dynamic">
                <div class="w-100 text-center">
                    <number class="number"
                            :from="0"
                            :to="352"
                            :duration="3"
                            :delay="1"
                            easing="Power1.easeOut" />
                    <hr />
                    <strong class="text-muted">سازمان ها</strong>
                    <p>تعداد سازمان های طرف قرارداد رامنیک</p>
                </div>
            </div>
            <div data-aos="fade-left"
                 data-aos-duration="1000"
                 class="col-lg-3 col-md-6 col-6 d-flex align-items-stretch float-dynamic">
                <div class="w-100 text-center">
                    <number class="number"
                            :from="0"
                            :to="511"
                            :duration="3"
                            :delay="1"
                            easing="Power1.easeOut" />
                    <hr />
                    <strong class="text-muted">شهر ها</strong>
                    <p>تعداد شهر هایی که رامنیک خدمات خود را ارائه میکند</p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        data()
        {
            return {};
        }
    };
</script>
<style scoped>
    .reports {
        background: #fff;
    }
</style>
